import type { ContentMap } from "./types";

export const contentUAEar: ContentMap = {
  // Hero
  "hero-eyebrow": "لأطباء اللوكم في جميع أنحاء الإمارات",
  "hero-h1": 'توقف عن الملاحقة.<br>ابدأ <span>العمل.</span>',
  "hero-sub":
    "كل وكالة مشاركة في الإمارات. تخصصك، درجتك، توفرك. نقرة واحدة للتقديم. لا مزيد من فوضى الرسائل.",

  // Problem
  "problem-h2": "هاتفك أصبح لوحة وظائف لم تشترك فيها.",
  "problem-p1":
    "أربعة تطبيقات وكالات. ثلاث مجموعات واتساب. مسؤول توظيف يتصل بشأن عيادة في الشارقة وأنت في دبي. نفس الوظيفة من وكالتين بأسعار مختلفة — ولا أحد يوضح ما ستكسبه فعلاً.",
  "problem-p2":
    "اخترت العمل المؤقت من أجل الاستقلالية، لا لتقضي ساعة كل صباح في فرز رسائل من أشخاص لا يعرفون تخصصك.",
  "problem-closer": "هذا يتوقف هنا.",

  // HIW prefs card values
  "hiw-prefs-loc":
    'دبي · ≤20 كم',
  "hiw-prefs-rate":
    '≥ 450 د.إ/ساعة',

  // HIW phone card
  "hiw-phone-title": "طبيب عام مؤقت · دبي مارينا",
  "hiw-phone-rate": "500 د.إ/ساعة",
  "hiw-phone-card2": "طبيب عام · JBR · 3 كم",
  "hiw-phone-card3": "مسجل · أبوظبي · ≤15 كم",

  // HIW apply card
  "hiw-job-title": "طبيب عام مؤقت · دبي مارينا",
  "hiw-ag0-rate": "500 د.إ/ساعة",
  "hiw-ag0-name": "ميداكس هيلثكير",
  "hiw-ag1-rate": "480 د.إ/ساعة",
  "hiw-ag1-name": "MSI جروب",
  "hiw-ag2-rate": "520 د.إ/ساعة",
  "hiw-ag2-name": "غلوب لوكمز",

  // Differentiator: credential
  "diff-cred-h3": "التحقق من الاعتماد مرة واحدة",
  "diff-cred-p":
    "التحقق عبر DHA/HAAD/DOH مرة واحدة، صالح في كل مكان. لا مزيد من إعادة رفع المستندات لكل وكالة.",

  // Testimonials
  "test-heading": "ماذا يقول لنا الأطباء.",
  "test-disclaimer":
    "من محادثات مع أطباء لوكم خلال بحثنا قبل الإطلاق. تم تغيير الأسماء للخصوصية.",
  "test1-quote":
    '\u201cأربع مجموعات واتساب فقط لإيجاد مناوبات في دبي. لو يجمعها أحد في خلاصة واحدة، سأنضم فوراً.\u201d',
  "test1-avatar": "أ",
  "test1-name": "طبيب طوارئ",
  "test1-title": "دبي",
  "test2-quote":
    '\u201cنفس وظيفة الجميرا من ثلاث وكالات بثلاثة أسعار. أريد فقط رؤية الأفضل والتقديم.\u201d',
  "test2-avatar": "ف",
  "test2-name": "طبيبة عامة",
  "test2-title": "أبوظبي",
  "test3-quote":
    '\u201cلا مزيد من المكالمات المسائية بشأن قائمة العمليات. دعني أحدد تفضيلاتي وأحصل على تطابق.\u201d',
  "test3-avatar": "ر",
  "test3-name": "طبيب تخدير",
  "test3-title": "دبي",

  // Trust strip
  "trust-cred-title": "معتمد من DHA / HAAD",
  "trust-cred-desc":
    "كل طبيب يتم التحقق من اعتماده عبر DHA أو HAAD أو DOH قبل أن يرى أي وظيفة",

  // CTA
  "cta-p":
    "انضم لقائمة الانتظار. كن أول من يصل إلى كل وظيفة مؤقتة في الإمارات — من كل وكالة مشاركة، في مكان واحد.",

  // Footer
  "footer-desc":
    "كل وظيفة مؤقتة، كل وكالة، في مكان واحد. صُمم لأطباء الإمارات الذين يريدون استعادة وقتهم.",
  "footer-made": "صُنع للإمارات",

  // Nav
  "nav-doctors": "للأطباء",
  "nav-agencies": "للوكالات",
  "nav-hospitals": "المستشفيات",
  "nav-cta": "سجّل اهتمامك",

  // Hero buttons & proof
  "hero-cta1": "احصل على وصول مبكر",
  "hero-cta2": "كيف يعمل",
  "waitlist-success": "أنت على القائمة. سنتواصل معك قريباً.",
  "waitlist-success-cta": "أنت على القائمة. سنتواصل معك قريباً.",
  "waitlist-hint": "لا بريد مزعج. فقط وصول مبكر عند الإطلاق.",
  "proof-1": "الأسعار على كل إعلان",
  "proof-2": "مطابق لتخصصك",
  "proof-3": "قدّم بنقرة واحدة",
  "proof-4": "كل الوكالات. خلاصة واحدة.",
  "proof-5": "اعتماد موثّق",
  "phone-date": "الاثنين، ١٤ أبريل",

  // Differentiators
  "diff-heading": "ما يمنحك إياه لوكم بلس ولا يمنحه أي شخص آخر.",
  "diff-feed-h3": "كل وكالة. خلاصة لوكم بلس واحدة.",
  "diff-feed-p":
    "توقف عن التنقل بين أربعة تطبيقات. لوكم بلس يجمع أدوار كل وكالة مشاركة في مكان واحد، بدون تكرار ومطابقة لملفك.",
  "diff-rates-h3": "الأسعار ظاهرة دائماً",
  "diff-rates-p":
    "كل إعلان يُظهر السعر مباشرة. لا تخمين، لا مكالمات محرجة. ترى ما ستكسبه قبل أن تقدّم.",
  "diff-apply-h3": "قدّم في ثوانٍ، لا ساعات",
  "diff-apply-p":
    "نقرة واحدة. لا خطابات تعريف، لا مكالمات متابعة. تابع كل طلب في الوقت الفعلي من نفس الشاشة.",
  "diff-match-h3": "مطابق لتفضيلاتك",
  "diff-match-p":
    "الدرجة، التخصص، نطاق الموقع، الحد الأدنى للسعر. الخلاصة تتكيف معك — وليس العكس.",
  "diff-ops-h3": "بناه مشغّلون، لا مستشارون",
  "diff-ops-p":
    "عقود من خبرة التوظيف الصحي وراء كل ميزة. صُنع هذا مع الوكالات، لا ضدها.",

  // Specialities
  "spec-heading": "كل تخصص. كل درجة.",
  "spec-sub": "من طب الطوارئ إلى طب النساء والتوليد — مطابق لاعتمادك.",
  "spec-chips":
    '<div class="speciality-chip">طب الطوارئ</div><div class="speciality-chip">الممارسة العامة</div><div class="speciality-chip">التخدير</div><div class="speciality-chip">طب الأطفال</div><div class="speciality-chip">جراحة العظام</div><div class="speciality-chip">الطب النفسي</div><div class="speciality-chip">النساء والتوليد</div><div class="speciality-chip">الطب الباطني</div><div class="speciality-chip">العناية المركزة</div><div class="speciality-chip">الأشعة</div><div class="speciality-chip">الجراحة</div><div class="speciality-chip">توليد الممارسة العامة</div>',

  // Experience stories
  "exp-heading": "مبني حول حياة اللوكم الحقيقية.",
  "exp-intro": "ليس كما تعتقد الوكالات أنك تعمل — بل كما تعمل فعلاً.",
  "exp1-h3": "اضبطه مرة واحدة، من أي مكان",
  "exp1-p":
    "التخصص، الدرجة، نطاق الموقع، الحد الأدنى للسعر. تفضيلات لوكم بلس تُصفّي كل شيء — فالخلاصة تُظهر فقط الأدوار التي ستقبلها فعلاً.",
  "exp2-h3": "كل وكالة. خلاصة لوكم بلس واحدة.",
  "exp2-p":
    "إعلانات كل وكالة مشاركة، بدون تكرار، مطابقة ومرتّبة. الأسعار ظاهرة على كل بطاقة. محدّثة فورياً.",
  "exp3-h3": "نقرة واحدة. عُد لقهوتك.",
  "exp3-p":
    "لا خطابات تعريف. لا مكالمات هاتفية. لا إعادة رفع سيرتك الذاتية. قدّم، تابع، أكّد — كل شيء من نفس الشاشة.",

  // Personas
  "persona-heading": "مبني حسب طريقة عملك الفعلية.",
  "persona-intro":
    "اللوكم ليس سنة فراغ. إنه استراتيجية مهنية. كل ميزة مصممة حول الطرق الخمس التي يستخدم بها الأطباء العمل المرن فعلاً.",
  "per1-h3": "الوالد الذي يحتاج ساعات المدرسة",
  "per1-p":
    "اعمل في الفصل الدراسي. خذ إجازة الصيف. قلّل إلى وردتين في الأسبوع بدون تفاوض. جدولك، لا جدول صاحب العمل.",
  "per2-h3": "الطبيب الذي غادر لسبب",
  "per2-p":
    "سياسات المستشفى، العبء الإداري، فقدان الاستقلالية السريرية. اللوكم هو زر إعادة التشغيل: رعاية سريرية نقية، نتائج واضحة، في المنزل بحلول الخامسة.",
  "per3-h3": "المتخصص الذي يبقى محدّثاً",
  "per3-p":
    "50 ساعة تطوير مهني سنوياً للحفاظ على التسجيل. وردتان في الشهر عبر بيئات مختلفة تبقي المعرفة حادة بدون العمل بدوام كامل.",
  "per4-h3": "باني الخبرة",
  "per4-p":
    "مسجّل أو متدرب دولي، يبني سيرة ذاتية عبر بيئات متعددة. تناوبات لوكم تُحسب للزمالة، لا مجرد ورديات تعبئة.",
  "per5-h3": "مغامر المناطق النائية",
  "per5-p":
    "أجر أعلى، تكاليف أقل، تنوع سريري. فترات إقليمية لمدة أسبوعين تصقل المهارات العامة وتُريح العقل.",

  // Audiences
  "aud-heading": "نفس السوق. مشكلتان.<br>منصة واحدة.",
  "aud-doc-h3": "للأطباء",
  "aud-doc-p":
    "وكالات كثيرة جداً. رسائل كثيرة جداً. لا رؤية للأسعار. لوكم بلس يضع كل وظيفة في خلاصة واحدة، مطابقة لملفك. أنت تقرر ما تقدّم عليه — لا ما تتصفحه.",
  "aud-doc-btn": "انضم كطبيب",
  "aud-ag-h3": "للوكالات",
  "aud-ag-p":
    "أفضل مرشحيك يغرقون في رسائل منافسيك. أرسل طلبات العملاء مرة واحدة — الأطباء المطابقون يقدّمون تلقائياً. لا جداول بيانات، لا ملاحقة أطباء بالهاتف.",
  "aud-ag-btn": "شارك معنا",

  // Trust
  "trust-enc-title": "تشفير بمستوى البنوك",
  "trust-enc-desc": "بياناتك مشفرة أثناء التخزين والنقل، دائماً",
  "trust-ops-title": "بناه مشغّلون",
  "trust-ops-desc": "عقود من خبرة التوظيف الصحي وراء كل ميزة",

  // CTA section
  "cta-h2": 'وردتك القادمة<br><span>بانتظارك.</span>',
  "cta-btn": "احصل على وصول مبكر",

  // Footer columns
  "foot-col1-title": "المنتج",
  "foot-col1-links":
    '<li><a href="#audiences">للأطباء</a></li><li><a href="#audiences">للوكالات</a></li><li><a href="#hiw-section">كيف يعمل</a></li><li><a href="#specialities">التخصصات</a></li>',
  "foot-col2-title": "الشركة",
  "foot-col2-links":
    '<li><span class="footer-link-disabled">عن لوكم بلس</span></li><li><a href="mailto:info@locumgroup.co">اتصل بنا</a></li><li><span class="footer-link-disabled">وظائف</span></li><li><span class="footer-link-disabled">المدونة</span></li>',
  "foot-col3-title": "قانوني",
  "foot-col3-links":
    '<li><a href="/privacy">الخصوصية</a></li><li><a href="/terms">الشروط</a></li><li><span class="footer-link-disabled">الأمان</span></li>',
  "footer-copy": "&copy; 2026 لوكم بلس. جميع الحقوق محفوظة.",

  // HIW big title
  "hiw-pill": "كيف يعمل",
  "hiw-hl1": ".الفوضى تدخل",
  "hiw-hl2": ".الأدوار المطابقة تخرج",
  "hiw-scroll-hint":
    "مرر لترى كيف نحوّل فوضى الوكالات إلى خلاصة واحدة من الوظائف المطابقة لك.",

  // HIW mobile fallback
  "hiw-pill-mobile": "كيف يعمل",
  "hiw-mobile-h": "الفوضى تدخل. الأدوار المطابقة تخرج.",
  "hiw-mobile-sub":
    "كيف يحوّل لوكم بلس فوضى الوكالات إلى خلاصة واحدة من الوظائف المطابقة لك.",
  "hiw-mob-s1-h": "الفوضى تصل",
  "hiw-mob-s1-p":
    "كل وكالة ترسل كل الأدوار \u2014 بالإضافة إلى المكالمات والرسائل والواتساب لملاحقتك بوظائف لن تقبلها أبداً.",
  "hiw-mob-s2-h": "تفضيلاتك",
  "hiw-mob-s2-p":
    "حدد الدرجة والتخصص ونطاق الموقع والسعر والتوفر. مرة واحدة.",
  "hiw-mob-s3-h": "التطابقات مكشوفة",
  "hiw-mob-s3-p":
    "لوكم بلس يقارن كل دور بتفضيلاتك \u2014 متطابق أو غير متطابق، يظهر مباشرة.",
  "hiw-mob-s4-h": "في التطبيق",
  "hiw-mob-s4-p":
    "الوظائف المطابقة تصل في خلاصة واحدة. لا إعلانات مكررة، لا مزيد من ملاحقة الهاتف.",
  "hiw-mob-s5-h": "قدّم بطريقتك",
  "hiw-mob-s5-p": "وظيفة واحدة. اختر الوكالة. قدّم بنقرة واحدة.",

  // HIW stepper labels
  "hiw-step1": "الفوضى تصل",
  "hiw-step2": "تفضيلاتك",
  "hiw-step3": "التطابقات",
  "hiw-step4": "في التطبيق",
  "hiw-step5": "قدّم بطريقتك",

  // HIW phase headings & subs
  "hiw-ph0-h": "الفوضى تصل",
  "hiw-ph0-sub":
    "كل وكالة ترسل كل الأدوار — بالإضافة إلى المكالمات والرسائل والواتساب لملاحقتك بوظائف لن تقبلها أبداً.",
  "hiw-ph1-h": "تفضيلاتك",
  "hiw-ph1-sub":
    "حدد الدرجة والتخصص ونطاق الموقع والسعر والتوفر. مرة واحدة.",
  "hiw-ph2-h": "التطابقات مكشوفة",
  "hiw-ph2-sub":
    "لوكم بلس يقارن كل دور بتفضيلاتك — متطابق أو غير متطابق، يظهر مباشرة.",
  "hiw-ph3-h": "في التطبيق",
  "hiw-ph3-sub":
    "الوظائف المطابقة تصل في خلاصة واحدة. لا إعلانات مكررة، لا مزيد من ملاحقة الهاتف.",
  "hiw-ph4-h": "قدّم بطريقتك",
  "hiw-ph4-sub": "وظيفة واحدة. اختر الوكالة. قدّم بنقرة واحدة.",

  // HIW prefs card
  "hiw-prefs-badge": "التفضيلات",
  "hiw-prefs-title": "فلتر لوكم بلس",
  "hiw-prefs-l-grade": "الدرجة",
  "hiw-prefs-v-grade":
    'استشاري · مسجّل · طبيب عام',
  "hiw-prefs-l-spec": "التخصص",
  "hiw-prefs-v-spec":
    'الممارسة العامة',
  "hiw-prefs-l-loc": "الموقع",
  "hiw-prefs-l-rate": "السعر",
  "hiw-prefs-l-shifts": "الورديات",
  "hiw-prefs-v-shifts":
    'نهاري فقط',

  // HIW phone/apply card
  "hiw-feed-title": "خلاصتي",
  "hiw-feed-matches": "٥ تطابقات",
  "hiw-match-badge": "تطابق",
  "hiw-phone-verified": "● موثّق",
  "hiw-view-agencies": "عرض · ٣ وكالات",
  "hiw-apply-title": "تقديم",
  "hiw-job-agencies": "١ وظيفة · ٣ وكالات",
  "hiw-verified": "موثّق",
  "hiw-apply-via": "قدّم عبر",
  "hiw-apply-caption": "وظيفة واحدة. اختر الوكالة.",
  "hiw-badge-verified": "موثّق",
  "hiw-badge-trusted": "موثوق",
  "hiw-badge-fastest": "أسرع رد",
};
